import React from 'react';

import { motion } from 'framer-motion';
import DOMPurify from 'isomorphic-dompurify';

import { descriptionVariants, framerCommon, imageVariants, titleVariants } from '../../framer.variants';
import { data_technology_behind } from './content';

export default function TechnologyBehind({ id }) {
  const { prefix, title, items } = data_technology_behind;
  return (
    <section id={id} className="gl-wrapper gl-wrapper-y overflow-hidden">
      <span className="gl-heading-3 text-demo-xr-blue">{prefix}</span>
      <h2
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }}
        className="gl-heading-2 text-white [&>span]:text-partner-nvidia"
      />

      <div className="items mt-11 flex flex-col gap-11 lg:mt-8 lg:gap-9">
        {items.map(({ id, title, icon, description, image }, idx) => (
          <div key={id} className="item flex gap-11 text-white even:flex-row-reverse 1100:gap-8 lg:gap-8 md:!flex-col">
            <div className="flex flex-col gap-7 md:gap-5">
              <motion.img
                {...framerCommon}
                variants={imageVariants(idx % 2 === 0)}
                width={52}
                height={52}
                className="relative h-[3.25rem] w-[3.25rem] lg:!static"
                src={icon}
              />
              <motion.h3
                {...framerCommon}
                variants={titleVariants}
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }}
                className="gl-heading-3 relative text-white lg:!static"
              />
              <motion.div
                {...framerCommon}
                variants={descriptionVariants}
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
                className="relative font-OpenSans font-medium lg:!static"
              />
            </div>
            <div className="min-w-[32.375rem] lg:min-w-[50%]">
              <motion.img
                {...framerCommon}
                variants={imageVariants(idx % 2 === 0)}
                className="relative w-full lg:!static"
                src={image}
                alt=""
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
